<template>
  <div class="safeOperation">
    <div class="top_content">
      <div class="title">
        <h2>安全运营服务</h2>
        <div class="content">
          安全运营是靠人的服务+体系化流程+智能化平台
          “三位一体”综合性解决方案，通过知己、知彼、分析、加固、事件处置动态循环持续输出价值，解决安全风险，从而实现安全的最终目标。
        </div>
      </div>
    </div>
    <div
      id="anchor1"
      class="demand"
    >
      <p class="title">
        安全运营的需求 <span style="color: #00c2b3"> | </span>
      </p>
      <div class="subtitle">
        由于企业网络常常面临着以下情况：
      </div>
      <div class="content">
        <div class="content_left">
          <div class="iten1">
            <div class="iten_title">
              安全体系建设不规范
            </div>
          </div>
          <img
            src="@/assets/security/safeOperation/xq1.png"
            alt=""
          >
          <div class="iten2">
            <div class="iten_title">
              人员安全意识不达标
            </div>
          </div>
          <img
            src="@/assets/security/safeOperation/xq2.png"
            alt=""
          >

          <div class="iten3">
            <div class="iten_title">
              供应链安全不重视
            </div>
          </div>
          <img
            src="@/assets/security/safeOperation/xq3.png"
            alt=""
          >

          <div class="iten4">
            <div class="iten_title">
              资产风险无从发现
            </div>
          </div>
          <img
            src="@/assets/security/safeOperation/xq4.png"
            alt=""
          >

          <div class="iten5">
            <div class="iten_title">
              全网网络攻击无从感知
            </div>
          </div>
        </div>
        <div class="content_center">
          <div>脆弱性增多</div>
          <img
            src="@/assets/security/safeOperation/img2.png"
            alt=""
          >
          <div>导致威胁攻击面扩大</div>
        </div>
        <div class="content_right">
          <img
            src="@/assets/security/safeOperation/img3.png"
            alt=""
          >
        </div>
      </div>
      <div class="subtitle1">
        <p>
          为了保护您的资产,所以您需要以运营者的视角看待网络安全战争，即使网络环境千变万化也能随机应变做出相应措施。
        </p>
      </div>
    </div>
    <div class="by_what">
      <p class="title">
        安全运营靠什么？
        <span style="color: #00c2b3"> | </span>
      </p>
      <div class="content">
        <img
          src="@/assets/security/safeOperation/ksm1.png"
          alt=""
        >
        <div class="center">
          <div class="people">
            <div>人</div>
            <img
              src="@/assets/security/safeOperation/ksm3.png"
              alt=""
            >
          </div>
          <div class="platform">
            <div>平台</div>
            <img
              src="@/assets/security/safeOperation/ksm2.png"
              alt=""
            >
          </div>
        </div>
        <div class="right">
          <div class="what1">
            <div class="what1_con">
              <div class="index">
                <div>1</div>
              </div>
              <el-divider />
              <div class="img">
                <img
                  src="@/assets/security/safeOperation/ksm4.png"
                  alt=""
                >
              </div>
              <div class="title">
                资产测绘
              </div>
            </div>
          </div>
          <div class="what2">
            <div class="what1_con">
              <div class="index">
                <div>2</div>
              </div>
              <el-divider />
              <div class="img">
                <img
                  src="@/assets/security/safeOperation/ksm5.png"
                  alt=""
                >
              </div>
              <div class="title">
                态势感知
              </div>
            </div>
          </div>
          <div class="what3">
            <div class="what1_con">
              <div class="index">
                <div>3</div>
              </div>
              <el-divider />
              <div class="img">
                <img
                  src="@/assets/security/safeOperation/ksm6.png"
                  alt=""
                >
              </div>
              <div class="title">
                运营管理
              </div>
            </div>
          </div>
          <div class="what4">
            <div class="what1_con">
              <div class="index">
                <div>4</div>
              </div>
              <el-divider />
              <div class="img">
                <img
                  src="@/assets/security/safeOperation/ksm7.png"
                  alt=""
                >
              </div>
              <div class="title">
                教培平台
              </div>
            </div>
          </div>
          <div class="what5">
            <div class="what1_con">
              <div class="index">
                <div>5</div>
              </div>
              <el-divider />
              <div class="img">
                <img
                  src="@/assets/security/safeOperation/ksm8.png"
                  alt=""
                >
              </div>
              <div class="title">
                应急工具箱
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="anchor2"
      class="cycle"
    >
      <p class="title">
        安全运营周期
        <span style="color: #00c2b3"> | </span>
      </p>
      <div class="cycle_content">
        <div class="cycle_left">
          <div class="title">
            通过安全运营周期性循环进行，
            <br>
            安全能力<span>无限接近100%</span>，
            <br>
            安全事故发生<span>概率接近于0</span>
          </div>
        </div>
        <div class="center_img">
          <div class="con1">
            <li>应急响应，取证溯源</li>
            <img
              src="@/assets/security/safeOperation/zq_img1.png"
              alt=""
            >
          </div>
          <div class="con2">
            <li>安全保护从掌握数字化资产开始</li>
            <img
              src="@/assets/security/safeOperation/zq_img2.png"
              alt=""
            >
          </div>
          <div class="con3">
            <li>全流量威胁检测</li>
            <img
              src="@/assets/security/safeOperation/zq_img3.png"
              alt=""
            >
          </div>
          <div class="con4">
            <li>资产分析</li>
            <li>威胁分析</li>
            <img
              src="@/assets/security/safeOperation/zq_img3.png"
              alt=""
            >
          </div>
          <div class="con5">
            <li>人防能力提升</li>
            <li>技防能力提升</li>
            <li>运维能力提升</li>
            <img
              src="@/assets/security/safeOperation/zq_img1.png"
              alt=""
            >
          </div>
          <img
            src="@/assets/security/safeOperation/zq1.png"
            alt=""
          >
        </div>
      </div>
    </div>
    <div
      id="anchor3"
      class="frame_diagram"
    >
      <p class="title">
        安全运营体系框架图
        <span style="color: #00c2b3"> | </span>
      </p>
      <div class="img">
        <img
          src="@/assets/security/safeOperation/kjt.jpg"
          alt=""
        >
      </div>
    </div>
    <div class="frame_diagram">
      <p class="title">
        知己知彼，百战不殆！
        <span style="color: #00c2b3"> | </span>
      </p>
      <div class="content">
        <div class="content_left">
          <div class="con">
            <p>被动防御</p>
            <p>主动防御</p>
          </div>
          <img
            src="@/assets/security/safeOperation/zjzb1.png"
            alt=""
          >
        </div>
        <div class="content_right">
          <div class="content_right_top">
            <img
              src="@/assets/security/safeOperation/zjzb2.png"
              alt=""
            >
            <div class="con">
              安全运营是对网络安全的动态掌控，只有让安全能力动起来，不断循环升级，才能破解复杂难题。让安全能力与日俱增，保护核心数据与业务系统。
            </div>
          </div>
          <div class="content_right_bottom">
            <img
              src="@/assets/security/safeOperation/zjzb2.png"
              alt=""
            >
            <div class="con">
              安全没有性价比，安全“一失万无”，用足够的资源，来满足我们对安全无限的需求；用专业高效的安全运营服务，来抵御复杂的网络攻击。
            </div>
          </div>
        </div>
      </div>
      <div class="content1">
        <p>
          安全运营是靠<span>人</span>的服务+体系化<span>流程</span>+智能化<span>平台</span>
          “三位一体”综合解决方案
        </p>
      </div>
    </div>
    <div
      id="anchor4"
      class="inventory"
    >
      <p class="title">
        安全运营创新实践 <span style="color: #00c2b3"> | </span>
      </p>
      <div class="inventory_content">
        <img
          src=""
          alt=""
        >
      </div>
      <!-- <div class="inventory_content">
        <div class="con_img">
          <div class="con_img_text">
            <p>人员服务</p>
            <p>运营平台</p>
          </div>
        </div>
        <div class="inventory_content_left">
          <div class="bg">
            <div class="bg_left">
              人员安全运维服务
            </div>
          </div>
          <div class="bg">
            <div class="bg_left">
              事件应急响应服务
            </div>
          </div>
          <div class="bg">
            <div class="bg_left">
              威胁情报分析服务
            </div>
          </div>
          <div class="bg">
            <div class="bg_left">
              专家研判分析服务
            </div>
          </div>
          <div class="bg">
            <div class="bg_left">
              漏洞发现修复服务
            </div>
          </div>
        </div>
        <div class="inventory_content_right">
          <div class="bg">
            <div class="bg_right">
              资产测绘平台
            </div>
          </div>
          <div class="bg">
            <div class="bg_right">
              态势感知平台
            </div>
          </div>
          <div class="bg">
            <div class="bg_right">
              运营管理平台
            </div>
          </div>
          <div class="bg">
            <div class="bg_right">
              教育培训平台
            </div>
          </div>
          <div class="bg">
            <div class="bg_right">
              应急工具平台
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'SafeOperation',
  data() {
    return {}
  },
  created() {
    if (this.$route.query.anchor) {
      setTimeout(() => {
        this.goAnchor(this.$route.query.anchor)
      }, 500)
    }
  },
  methods: {
    goAnchor(selector) {
      document.querySelector(selector).scrollIntoView({
        top: 500,
        behavior: 'smooth'
      })
    }
  }
}
</script>
<style lang="less" scoped>
.safeOperation {
  width: 100%;
  min-width: 1300px;
  background: #fff;
  #anchor1,
  #anchor2,
  #anchor3 {
    padding-top: 60px;
  }
  .top_content {
    background-image: url('../../assets/security/risk/topbg.png');
    background-size: 100% 100%;
    height: 400px;
    margin-top: -20px;

    .title {
      width: 35%;
      margin-left: 15%;
      padding-top: 100px;
      font-size: 16px;

      .content {
        line-height: 30px;
        color: #333;
      }
    }
  }
  .demand {
    width: 100%;
    .title {
      width: 80%;
      margin: 0 auto;
      font-size: 20px;
      margin-bottom: 20px;
    }
    .subtitle {
      width: 80%;
      margin: 0 auto;
      font-size: 18px;
      display: block;
      font-weight: normal;
      line-height: 35px;
      color: #333;
    }
    .content {
      margin: 0 auto;
      margin-top: 50px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 80%;

      .content_left {
        img {
          width: 30px;
          margin-top: -5px;
          margin-left: 43%;
        }
        .iten_title {
          padding: 15px 20px;
          color: #fff;
          font-size: 16px;
          text-align: center;
        }
        .iten1 {
          background: #70ad47;
          border-radius: 5px;
        }
        .iten2 {
          background: #5b9bd5;
          border-radius: 5px;
        }
        .iten3 {
          background: #ffc000;
          border-radius: 5px;
        }
        .iten4 {
          background: #a5a5a5;
          border-radius: 5px;
        }
        .iten5 {
          background: #c3753f;
          border-radius: 5px;
        }
      }
      .content_center {
        div:nth-child(1) {
          padding-top: 50px;
        }
        div {
          font-size: 18px;
        }
        img {
          width: 100px;
          height: auto;
          margin: 10px auto;
        }
      }
      .content_right {
        img {
          width: 500px;
          height: auto;
        }
      }
    }
    .subtitle1 {
      width: 80%;
      margin: 0 auto;
      font-size: 18px;
      display: block;
      font-weight: normal;
      line-height: 35px;
      color: #333;
    }
  }
  .by_what {
    width: 100%;
    .title {
      width: 80%;
      margin: 0 auto;
      font-size: 20px;
      padding-top: 40px;
      margin-bottom: 20px;
    }
    .content {
      width: 80%;
      margin: 50px auto;
      display: flex;
      align-items: center;
      img {
        width: 340px;
        // width: 20%;
        height: auto;
        margin-left: 16%;
      }
      .center {
        width: 300px;
        // width: 20%;
        height: 300px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        background: #203965;
        color: #fff;
        font-size: 18px;
        text-align: center;
        .people {
          margin: 0 auto;
          img {
            width: 100px;
            height: auto;
            margin-top: 10px;
          }
        }
        .platform {
          margin: 0 auto;
          img {
            width: 100px;
            height: auto;
            margin-top: 10px;
          }
        }
      }
      .right {
        background-image: url('../../assets/security/safeOperation/ksm9.png');
        background-size: 100% 100%;
        height: 370px;
        width: 150px;

        position: relative;

        .what1_con {
          display: flex;
          align-items: center;
          width: 100%;
          .index {
            background: #203965;
            width: 66px;
            height: 40px;
            color: #fff;
            border-radius: 50%;

            div {
              text-align: center;
              font-size: 18px;
              padding-top: 8px;
            }
          }
          .img {
            width: 100px;
            height: 60px;
            background: #203965;
            border-radius: 50%;
            text-align: center;
            display: flex;
            align-items: center;

            img {
              margin: 0 auto;
              width: 30px;
              height: 30px;
            }
          }
          .el-divider {
            width: 100px;
            height: 3px;
            border-radius: 10px;
            background: #203965;
            margin: 0 50px;
          }
          .title {
            width: 100%;
            display: flex;
            align-items: center;
            margin-bottom: 30px;
            margin-left: 10px;
          }
        }
        .what1 {
          width: 500%;
          position: absolute;
          top: 0;
          left: 50%;
        }
        .what2 {
          width: 500%;
          position: absolute;
          top: 18%;
          left: 80%;
        }
        .what3 {
          width: 500%;
          position: absolute;
          top: 40%;
          left: 85%;
        }
        .what4 {
          width: 500%;
          position: absolute;
          top: 59%;
          left: 78%;
        }
        .what5 {
          width: 500%;
          position: absolute;
          bottom: 0;
          left: 50%;
        }
      }
    }
  }
  .cycle {
    width: 100%;

    .title {
      width: 80%;
      margin: 0 auto;
      font-size: 20px;
      margin-bottom: 20px;
    }
    .cycle_content {
      width: 80%;
      margin: 0 auto 100px;
      .cycle_left {
        background-image: url('../../assets/security/safeOperation/zq2.png');
        background-size: 100% 100%;
        width: 350px;
        height: 300px;

        display: flex;
        align-items: center;
        .title {
          font-size: 18px;
          span {
            color: #ff0000;
          }
        }
      }
      .center_img {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: -120px;
        img {
          width: 500px;
          height: auto;
        }
        position: relative;
        .con1 {
          position: absolute;
          top: 35%;
          left: 17%;
          img {
            margin-top: -50px;
            width: 250px;
            height: auto;
          }
        }
        .con2 {
          position: absolute;
          top: -18%;
          left: 54%;
          li {
            text-align: center;
            width: 200px;
            margin-left: 30px;
          }
          img {
            margin-top: 10px;
            width: 250px;
            height: auto;
          }
        }
        .con3 {
          position: absolute;
          top: 34%;
          left: 67%;
          li {
            text-align: center;
            width: 200px;
            margin-left: 30px;
          }
          img {
            margin-top: -20px;
            width: 250px;
            height: auto;
          }
        }
        .con4 {
          position: absolute;
          top: 80%;
          left: 62%;
          li {
            text-align: center;
            width: 200px;
            margin-left: 30px;
          }
          img {
            margin-top: -20px;
            width: 250px;
            height: auto;
          }
        }
        .con5 {
          position: absolute;
          top: 76%;
          left: 22%;
          li {
            text-align: center;
            width: 200px;
            margin-left: 10px;
          }
          img {
            margin-top: -20px;
            width: 250px;
            height: auto;
          }
        }

        @media (min-width: 0) and (max-width: 1300px) {
          .con1 {
            position: absolute;
            top: 35%;
            left: 2%;
          }
          .con2 {
            position: absolute;
            top: -16%;
            left: 53%;
          }
          .con3 {
            position: absolute;
            top: 35%;
            left: 76%;
          }
          .con4 {
            position: absolute;
            top: 80%;
            left: 68%;
          }
          .con5 {
            position: absolute;
            top: 82%;
            left: 7%;
          }
        }
        @media (min-width: 1300px) and (max-width: 1400px) {
          .safeOperation .by_what .content img{
            margin-left: 20% !important;
          }
          .con1 {
            position: absolute;
            top: 35%;
            left: 2%;
          }
          .con2 {
            position: absolute;
            top: -22%;
            left: 52%;
          }
          .con3 {
            position: absolute;
            top: 35%;
            left: 75%;
          }
          .con4 {
            position: absolute;
            top: 80%;
            left: 68%;
          }
          .con5 {
            position: absolute;
            top: 80%;
            left: 8%;
          }
        }
        @media (min-width: 1400px) and (max-width: 1500px) {
          .con1 {
            position: absolute;
            top: 35%;
            left: 7%;
          }
          .con2 {
            position: absolute;
            top: -22%;
            left: 52%;
          }
          .con3 {
            position: absolute;
            top: 35%;
            left: 72%;
          }
          .con4 {
            position: absolute;
            top: 80%;
            left: 66%;
          }
          .con5 {
            position: absolute;
            top: 80%;
            left: 12%;
          }
        }
        @media (min-width: 1500px) and (max-width: 1600px) {
          .con1 {
            position: absolute;
            top: 35%;
            left: 8%;
          }
          .con2 {
            position: absolute;
            top: -22%;
            left: 52%;
          }
          .con3 {
            position: absolute;
            top: 35%;
            left: 71%;
          }
          .con4 {
            position: absolute;
            top: 80%;
            left: 66%;
          }
          .con5 {
            position: absolute;
            top: 80%;
            left: 14%;
          }
        }
        @media (min-width: 1600px) and (max-width: 1800px) {
          .con1 {
            position: absolute;
            top: 35%;
            left: 11%;
          }
          .con2 {
            position: absolute;
            top: -22%;
            left: 52%;
          }
          .con3 {
            position: absolute;
            top: 35%;
            left: 70%;
          }
          .con4 {
            position: absolute;
            top: 80%;
            left: 66%;
          }
          .con5 {
            position: absolute;
            top: 80%;
            left: 15%;
          }
        }
      }
    }
  }
  .frame_diagram {
    width: 100%;
    margin: 0 auto;

    .title {
      width: 80%;
      margin: 0 auto;
      font-size: 20px;
      margin-bottom: 20px;
    }
    .img {
      width: 80%;
      margin: 0 auto;
      img {
        width: 100%;
        height: auto;
      }
    }
    .content {
      width: 80%;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      .content_left {
        display: flex;
        justify-content: center;
        img {
          width: 300px;
          height: auto;
        }
        position: relative;
        .con {
          font-size: 18px;
          font-weight: bold;
          position: absolute;
          top: 50px;
          p:nth-child(1) {
            margin-left: 45px;
          }
          p:nth-child(2) {
            margin-top: 76px;
            margin-right: 60px;
          }
        }
      }
      .content_right {
        width: 40%;
        border: 1px solid #2f528f;
        padding: 30px;
        border-radius: 30px;
        img {
          width: 120px;
          height: 80px;
        }
        .con {
          font-size: 16px;
          line-height: 30px;
          display: flex;
          align-items: center;
          margin-left: 15px;
        }
        .content_right_top {
          display: flex;
        }
        .content_right_bottom {
          margin-left: 40px;
          margin-top: 15px;
          display: flex;
          img {
            transform: rotate(180deg);
          }
        }
      }
    }
    .content1 {
      width: 45%;
      margin: 0 auto;
      margin-top: 20px;
      display: flex;
      align-items: center;
      span {
        color: #ff0000;
      }
    }
  }
  .inventory {
    width: 100%;
    margin: 0 auto;
    margin-bottom: 50px;

    .title {
      width: 80%;
      margin: 0 auto;
      font-size: 20px;
      padding-top: 40px;
      margin-bottom: 30px;
    }

    .inventory_content {
      width: 60%;
      min-width: 900px;
      margin: 0 auto;
      //background-image: url('../../assets/security/safeOperation/qd_bg.png');
      background-image: url('../../assets/security/safeOperation/pic.png');

      background-size: 100% 100%;
      height: 500px;
      // height: auto;
      display: flex;
      justify-content: space-between;
      position: relative;
      .con_img {
        position: absolute;
        top: 22%;
        left: 41%;
        background-image: url('../../assets/security/safeOperation/qd_con_img.png');
        background-size: 100% 100%;
        width: 200px;
        height: 200px;

        .con_img_text {
          height: 200px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          p {
            font-size: 20px;
            width: 18px;
            color: #fff;
            font-weight: bold;
          }
        }
      }
      .bg {
        width: 260px;
        background: #fff;
        height: 66px;
        border: 1px solid #cccccc;
        text-align: center;
        .bg_left {
          width: 250px;
          height: 60px;
          line-height: 60px;
          font-size: 18px;
          background: #b10606;
          color: #fff;
          margin-top: 3px;
          margin-left: 5px;
        }
        .bg_right {
          width: 250px;
          height: 60px;
          line-height: 60px;
          font-size: 18px;
          background: #06225b;
          color: #fff;
          margin-top: 3px;
          margin-left: 5px;
        }
      }
      .bg:nth-child(1) {
        margin-top: 0;
      }
      .bg:nth-child(2) {
        margin-top: 17px;
      }
      .bg:nth-child(3) {
        margin-top: 16px;
      }
      .bg:nth-child(4) {
        margin-top: 10px;
      }
      .bg:nth-child(5) {
        margin-top: 18px;
      }
    }
  }
}
@media screen and (min-width: 1200px) and (max-width: 1350px) {
  .safeOperation .by_what .content img{
    margin-left: -2%;
  }

}
@media screen and (min-width: 1350px) and (max-width: 1500px) {
  .safeOperation .by_what .content img{
    margin-left: 0%;
  }

}
@media screen and (min-width: 1500px) and (max-width: 1700px){
  .safeOperation .by_what .content img{
    margin-left: 8%;
  }
}
</style>
